import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box, Alert, CircularProgress } from '@mui/material';
import { Icon } from '@iconify/react';
interface CancelTransactionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
  transactionId: string;
  cancellationAction: string;
}
const CancelTransactionDialog: React.FC<CancelTransactionDialogProps> = ({
  open,
  onClose,
  onConfirm,
  transactionId,
  cancellationAction
}) => {
  const [reason, setReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const handleConfirm = async () => {
    if (!reason.trim()) {
      setError('Cancellation reason is required');
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      await onConfirm(reason);
      setReason('');
      onClose();
    } catch (err) {
      setError('Failed to submit cancellation request');
    } finally {
      setIsLoading(false);
    }
  };
  const handleClose = () => {
    if (!isLoading) {
      setReason('');
      setError(null);
      onClose();
    }
  };
  return <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth data-id="element-362" data-mp="31fxm4k9vvsov">
      <DialogTitle data-id="element-363" data-mp="35ic7pc4xt6ju">
        <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }} data-id="element-364" data-mp="35iu7giqt62wi">
          <Icon icon="lucide:alert-triangle" width={24} color="#EF4444" data-id="element-365" data-mp="3ahf0ny7n7mbg" />
          <Typography variant="h6" fontWeight={600} data-id="element-366" data-mp="3ffgu9d2p3416">
            Cancel Transaction
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent data-id="element-367" data-mp="3k9uhgs77e4ur">
        <Box sx={{
        mt: 1
      }} data-id="element-368" data-mp="3p6bfqf849zlk">
          <Typography variant="body2" color="text.secondary" sx={{
          mb: 2
        }} data-id="element-369" data-mp="3p8ntshar7ptc">
            Transaction ID: <strong data-id="element-370" data-mp="22n7onbikpt0">{transactionId}</strong>
          </Typography>

          <Alert severity="warning" sx={{
          mb: 2
        }} data-id="element-371" data-mp="1y4i9811xd47h">
            <Typography variant="body2" fontWeight={600} data-id="element-372" data-mp="1u4g41hwzdsng">
              Action: {cancellationAction.replace(/_/g, ' ')}
            </Typography>
          </Alert>

          <TextField label="Cancellation Reason" placeholder="Enter reason for cancellation..." multiline rows={4} fullWidth required value={reason} onChange={e => {
          setReason(e.target.value);
          setError(null);
        }} error={!!error} helperText={error} disabled={isLoading} data-id="element-373" data-mp="23438kcl0bekq" />
        </Box>
      </DialogContent>
      <DialogActions sx={{
      px: 3,
      pb: 2
    }} data-id="element-374" data-mp="2lsro0j0q0rp4">
        <Button onClick={handleClose} disabled={isLoading} data-id="element-375" data-mp="whqummzy8drk">
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleConfirm} disabled={isLoading || !reason.trim()} startIcon={isLoading ? <CircularProgress size={16} color="inherit" data-id="element-377" data-mp="385441ola5jq4" /> : <Icon icon="lucide:x-circle" width={16} data-id="element-378" data-mp="2ub3e9kcb371w" />} data-id="element-376" data-mp="rie8k4gwjaq1">
          Submit Cancellation
        </Button>
      </DialogActions>
    </Dialog>;
};
export default CancelTransactionDialog;